import { NgModule } from '@angular/core';

import { ErrorReportingService } from './error-reporting.service';

@NgModule({
  providers: [ErrorReportingService],
})
export class ErrorReportingModule {}
